module.exports = __webpack_public_path__ + "img/advantages-back-768_1x.db10767c.jpg";